<template>
    <AdaptersSidebar
        v-if="visible"
        v-model:visible="visible"
        position="left"
        :blockScroll="true"
        :baseZIndex="100000"
        :modal="true"
        :showCloseIcon="false"
        class="menu_settings__sidebar"
    >
        <template #header>
            <div class="flex flex-column gap-3 w-full">
                <span>{{ $t('lang.menu.left_menu_setting_title') }}</span>
                <div class="field-switcher menu_settings__menu_switcher m-0 my-3 w-full justify-content-between">
                    <label for="option-left-menu">{{ $t('lang.menu.left_menu_setting') }}</label>
                    <InputSwitch v-model="model.isLeftMenu" @update:modelValue="onChangeLeftMenu" inputId="option-left-menu" />
                </div>
                <span class="font-bold text-sm">{{ $t('lang.menu.left_menu_favorites', [getFavoriteItemsLength, getMaxFavoriteLimit]) }}</span>
                <PanelMenu :model="getFavoriteItems" v-model:expanded-keys="expandedFavoriteKeys">
                    <template #item="{item, active, hasSubmenu}">
                        <div class="menu_items__item">
                            <div class="menu_items__item_label flex justify-content-between align-items-center w-full">
                                <div class="flex align-items-center gap-2">
                                    <i :class="item.icon"></i>
                                    <span>{{ item.label }}</span>
                                </div>
                                <i v-if="!hasSubmenu" class="ksi ksi-star menu_items__star_selected" @pointerdown="onRemoveFavorite(item.itemId)"></i>
                            </div>
                            <template v-if="hasSubmenu">
                                <!-- v-show необходим, т.к. при исчезновении элемента из DOM при фокусе - закрывается меню -->
                                <i v-show="active" class="pi pi-chevron-up"></i>
                                <i v-show="!active" class="pi pi-chevron-down"></i>
                            </template>
                        </div>
                    </template>
                </PanelMenu>
                <span class="font-bold text-sm inline mb-2">{{ $t('lang.menu.left_menu_other_tools') }}</span>
            </div>
        </template>
        <PanelMenu
            :model="getAnotherItems"
            v-model:expanded-keys="expandedKeys"
            :pt="{
                panel: {class: 'md:block'}
            }"
        >
            <template #item="{item, active, hasSubmenu}">
                <div v-if="!item.separator" class="menu_items__item">
                    <div
                        class="menu_items__item_label flex justify-content-between align-items-center w-full"
                    >
                        <div class="flex align-items-center gap-2">
                            <i :class="item.icon"></i>
                            <span>{{ item.label }}</span>
                        </div>
                        <i
                            v-if="!hasSubmenu && item.itemId"
                            class="ksi ksi-star"
                            @pointerdown="onAddFavorite(item.itemId)"
                            :class="{'p-disabled': isMaxLimitsFavorite}"
                        ></i>
                    </div>
                    <template v-if="hasSubmenu">
                        <!-- v-show необходим, т.к. при исчезновении элемента из DOM при фокусе - закрывается меню -->
                        <i v-show="active" class="pi pi-chevron-up"></i>
                        <i v-show="!active" class="pi pi-chevron-down"></i>
                    </template>
                </div>
            </template>
        </PanelMenu>
    </AdaptersSidebar>
</template>

<script>
import AdaptersSidebar from "../../adapters/Sidebar.vue";
import {Listeners} from "../../../constants/listeners";
import Divider from "primevue/divider";
import PanelMenu from "primevue/panelmenu";
import InputSwitch from "primevue/inputswitch";
import {ArrayHelper} from "../../../helpers/ArrayHelper";
import UserApi from "../../../api/UserApi";
import Alerts from "../../../mixins/Alerts";
import {MainMenu} from "../constants/MainMenu";

export default {
    name: "MenuSettings",
    mixins: [Alerts],
    data() {
        return {
            model: {
                items: {},
                favoriteItems: {},
                isLeftMenu: false,
            },
            visible: false,
            expandedKeys: {},
            expandedFavoriteKeys: {
                'favorites-main': true,
            },
        };
    },
    mounted() {
        this.$emitter.on(Listeners.LEFT_MENU_SETTINGS, (dataModel) => this.onOpenSetting(dataModel));
    },
    computed: {
        getFavoriteItems() {
            return this.model.favoriteItems;
        },
        getFavoriteItemsLength() {
            return this.model.favoriteItems[0].items.length;
        },
        getAnotherItems() {
            return this.recursiveFilterItems(
                this.model.items,
                ArrayHelper.getUniqueAttrValuesOfObjectsByName(this.model.favoriteItems[0].items, 'itemId')
            );
        },
        isMaxLimitsFavorite() {
            return this.getFavoriteItemsLength >= this.getMaxFavoriteLimit;
        },
        getMaxFavoriteLimit() {
            return MainMenu.FAVORITE_ITEMS_LIMIT;
        },
    },
    methods: {
        recursiveFilterItems(items, excludedItemIds) {
            return items
                .filter(item => !excludedItemIds.includes(item.itemId) || !item.itemId)
                .map(item => {
                    if (item.items) {
                        const filteredChildren = this.recursiveFilterItems(item.items, excludedItemIds);
                        return { ...item, items: filteredChildren };
                    }
                    return item;
                });
        },
        onOpenSetting(dataModel) {
            this.model = dataModel;
            this.setExpanded();
            this.visible = true;
        },
        setExpanded() {
            let expanded = {};
            // проверяем, не является ли данная страница родительской
            for (const [key, item] of Object.entries(this.model.items)) {
                expanded[item.key] = true;
            }

            this.expandedKeys = expanded;
        },
        onChangeLeftMenu(value) {
            UserApi
                .setSettings({isLeftMenu: value})
                .then(() => window.location.reload())
                .catch(error => this.alertError(error));
        },
        onAddFavorite(itemId) {
            this.$emitter.emit(Listeners.LEFT_MENU_ADD_FAVORITE, itemId);
        },
        onRemoveFavorite(itemId) {
            this.$emitter.emit(Listeners.LEFT_MENU_REMOVE_FAVORITE, itemId);
        },
    },
    components: {
        InputSwitch,
        PanelMenu,
        Divider,
        AdaptersSidebar,
    }
}
</script>

<style scoped>
.menu_items__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 8px;
    padding: 12px 14px;
    cursor: pointer;
    text-decoration: none;
    position: relative;
    border-radius: var(--border-radius);
}
.menu_items__item .menu_items__item_label {
    display: flex;
    align-items: center;
    column-gap: 8px;
    text-decoration: none;
}
.menu_items__item span {
    font-size: 13px;
    font-weight: 400;
    color: #CED4DA;
    line-height: 1.2;
}
.menu_items__item .menu_items__item_label i {
    font-size: 24px;
    color: #A4B1BE;
}
.menu_items__item i {
    font-size: 13px;
    color: #6C757D;
}
.menu_settings__menu_switcher label {
    margin-left: 0;
    color: #fff;
}
.menu_items__star_selected {
    color: var(--highlight-text-color) !important;
}
</style>

<style>
.menu_settings__sidebar.p-sidebar {
    background-color: #33404d;
    color: #fff;
    padding: 0 5px 25px;
}
.menu_settings__sidebar .p-sidebar-header {
    padding-bottom: 8px;
    padding-right: 10px;
    padding-left: 5px;
}
.menu_settings__sidebar .p-sidebar-content {
    padding: 0 5px;
}
.menu_settings__sidebar .p-panelmenu-header .p-panelmenu-header-content {
    background-color: #33404D !important;
}
.menu_settings__sidebar .p-panelmenu-header:not(.p-disabled).p-highlight .p-panelmenu-header-content,
.menu_settings__sidebar .p-panelmenu-content,
.menu_settings__sidebar .p-menuitem-content {
    background-color: #475569 !important;
}
/* hover */
.menu_settings__sidebar .menu_items__item,
.menu_settings__sidebar .menu_items__item span,
.menu_settings__sidebar .menu_items__item i {
    transition: all .3s;
}
.menu_settings__sidebar .menu_items__item:hover {
    background-color: #556275;
}
.menu_settings__sidebar .menu_items__item:hover > .menu_items__item_label span,
.menu_settings__sidebar .menu_items__item:hover > .menu_items__item_label i {
    color: #fff;
}
.menu_settings__sidebar .p-panelmenu-header-content,
.menu_settings__sidebar .p-panelmenu-content {
    border: unset !important;
}
.menu_settings__sidebar .p-panelmenu-header-content {
    box-shadow: none !important;
}



/* стилизация скролла для меню */
.menu_settings__sidebar div::-webkit-scrollbar {
    width: 3px; /* Ширина вертикального скроллбара */
    height: 3px; /* Высота горизонтального скроллбара */
    border-radius: 3px; /* Закруглённые края */
}
/* Ползунок (бегунок) */
.menu_settings__sidebar div::-webkit-scrollbar-thumb {
    background: #586A84; /* Цвет бегунка */
    border-radius: 3px; /* Закруглённые края */
}
/* Ползунок при наведении */
.menu_settings__sidebar div::-webkit-scrollbar-thumb:hover {
    background: #586A84;
}
/* Фон скроллбара */
.menu_settings__sidebar div::-webkit-scrollbar-track {
    background: #475569;
    border-radius: 3px;
}
</style>
